import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product } from '@idealsupply/products-api-angular-client';
import { WithProductId } from 'products-data';
import { ProductResultListComponent } from '../../../../../layouts/product-result/product-result-list';

@Component({
  selector: 'ideal-product-alternates-view',
  imports: [ProductResultListComponent],
  templateUrl: './product-alternates-view.component.html',
  styleUrl: './product-alternates-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductAlternatesViewComponent {
  public readonly alternates = input.required<WithProductId<Product>[]>();
  protected readonly alternateIds = computed(() => this.alternates().map((product) => product.id));
}
